import React, { Suspense, lazy, useEffect } from 'react';
import Hero from "../hero/Hero";
import Article from "../article/Article"
import { FaRegFilePdf } from "react-icons/fa";
import { Helmet } from "react-helmet";
import Placeholder from '../generic/Placeholder'


const Features = lazy(() => import("../features/Features"))
const Pricing = lazy(() => import("../pricing/Pricing"))
const ContactForm = lazy(() => import("../contact-form/ContactForm"))
const QuestionsAndAnswers = lazy(() => import("../questions-and-answers/QuestionsAndAnswers"))
const Resources = lazy(() => import("../resources/Resources"))
const Presentations = lazy(() => import("../presentations/Presentations"))

const resourcesList = [
    {
        icon: <FaRegFilePdf/>,
        title: "Mailwall Email Filtering Brochure",
        source: "resources/downloads/Mailwall-Email-Filtering-Brochure.pdf",
    },
    {
        icon: <FaRegFilePdf/>,
        title: "Mailwall Email Filtering User Guide",
        source: "resources/downloads/Mailwall-Email-Filtering-Remote-User-Guide.pdf",
    }
]


const PageMailwall = () => {
    return (
        <>
            <Helmet>
                <title>Mailwall - Email Filtering</title>
                <meta name="description" content="Mailwall - advanced email filtering services for business. See how Omniquad's email protection can meet all your online security needs."/>
            </Helmet>

            <main className={"Page"}>
                <Hero showButtons mailwallTrial>
                    <h1>Mailwall - Cloud Email Filtering For Business</h1>
                    <p>All-in-One Email Filtering with double anti-virus protection & anti-spam filtering. Protect your organization & users from spam, viruses, malware & ransomware before they harm your business with a 99.99% spam detection rate. Prevent zero-day attacks without changing the email flow.</p>
                    <p>Email security gateways specifically developed to meet the demands of modern Business, with endpoint encryption using TLS, DMARC, SPF & DKIM..</p>
                    <ul>
                        <li><strong>99.9% Guaranteed up-time</strong></li>
                        <li><strong>24/7 Support</strong></li>
                        <li><strong>Simple & Intuitive</strong></li>
                        <li><strong>Robust Email filtering</strong></li>
                        <li><strong>Stops 100% of Viruses</strong></li>
                        <li><strong>Stops 99.99% Spam</strong></li>
                    </ul>
                </Hero>
                <Article>
                    <Suspense fallback={<Placeholder />}>
                        <Features dataFile="featuresData.js" />
                    </Suspense>
                </Article>
            </main>
            <Suspense fallback={<Placeholder />}>
                <Pricing/>
                <ContactForm variant={"mailwall"} />
                <QuestionsAndAnswers/>
                <Resources resourcesList={resourcesList}/>
                <Presentations/>
            </Suspense>
        </>
    )
}

export default PageMailwall;